/* eslint-disable indent */
import DialogActions from '@mui/material/DialogActions';
import styled from 'styled-components';

import { COLORS } from '../../../../../theme';

export const StyledDialogActions = styled(DialogActions)`
  && {
    padding: ${({ theme }) => theme.spacing.m2};
    ${({ $border }) =>
      $border &&
      `
      border-top: 1px solid ${COLORS.black10};
    `}
    ${({ $noMargin }) => $noMargin && 'margin: 0;'}
  }

  .MuiButton-root + .MuiButton-root {
    margin-left: ${({ theme }) => theme.spacing.s3};
  }
`;
